import { uniqueId } from '@/components/home/Contents'
import { assets } from '@/helpers/common'
import { domAnimation, LazyMotion, m } from 'framer-motion'

function PrivacyPolicyBanner() {
  return (
    <>
      <section className={'section-spacing--small with-banner bg-white-ice-three'}>
        <div className='main-banner'>
          <div className='container mx-auto relative desktop-banner'>
            <div className='flex justify-between items-center'>
              <div>
                <LazyMotion features={domAnimation}>
                  <m.div
                    className='inline-block'
                    key={uniqueId('animation-')}
                    animate={{ scale: 1, y: 0, opacity: 1 }}
                    transition={{ duration: 0.7 }}
                    initial={{ scale: 0.8, y: 100, opacity: 0 }}
                  >
                    <div className='banner-content text-right'>
                      <h1 className='text-4xl2 sm-mx:text-2xl font-bold text-secondary mb-4'>Privacy Policy</h1>
                    </div>
                  </m.div>
                </LazyMotion>
              </div>
              <div>
                <img className='inline-block' src={assets('images/privacy-policy.png')} alt={'privacy-policy'} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default PrivacyPolicyBanner
